/**
 * The run summary. SPEC-0002 §5.
 *
 * Exact and estimated exposure are shown as two figures and never summed into
 * one number — the whole point of flagging an estimate is lost if it is then
 * silently added to a measured total.
 */
import type { RunSummary } from '@picklii/recon';
import { money } from '../lib/format';
import { Icon } from './Icon';

export function RunSummaryStats({ summary }: { summary: RunSummary }) {
	const findingCount = Object.values(summary.findingCountsByType).reduce((a, b) => a + b, 0);

	return (
		<section className="stats stats-vertical bg-base-200 border-base-300 xl:stats-horizontal col-span-12 border shadow-xs">
			<div className="stat">
				<div className="stat-figure">
					<Icon name="warning" className="size-7 opacity-70" />
				</div>
				<div className="stat-title">Findings</div>
				<div className="stat-value text-xl font-semibold tabular-nums">{findingCount}</div>
				<div className="stat-desc">
					{summary.findingCountsByBand.Critical} critical · {summary.findingCountsByBand.High} high
				</div>
			</div>

			<div className="stat">
				<div className="stat-title">Exposure — measured</div>
				<div className="stat-value text-xl font-semibold tabular-nums">
					{money(summary.exactExposureCents)}
				</div>
				<div className="stat-desc">Rates taken from the SOW</div>
			</div>

			<div className="stat">
				<div className="stat-title">Exposure — estimated</div>
				<div className="stat-value text-xl font-semibold tabular-nums">
					{money(summary.estimatedExposureCents)}
				</div>
				<div className="stat-desc">Derived rates — reported separately, never summed</div>
			</div>

			<div className="stat">
				<div className="stat-figure">
					<Icon name="question" className="size-7 opacity-70" />
				</div>
				<div className="stat-title">Needs attention</div>
				<div className="stat-value text-xl font-semibold tabular-nums">
					{summary.unscoredFindingCount + summary.unmatchedRoleCount}
				</div>
				<div className="stat-desc">
					{summary.unscoredFindingCount} unscored · {summary.unmatchedRoleCount} unmatched roles
				</div>
			</div>
		</section>
	);
}
